var isRedesign = $('.vr-slider-body').length > 0,
    bLazyPageSettings = {
        selector: '.b-lazy',
        offset: 300,
        loadInvisible: true,
        success: function(elem) {
            if (!isMobile && $(elem).closest('.vr-related__content-wrap').length > 0) {
                fireEvent(window, 'view.related.left.img.loaded');
            }
        }
    },
    bLazySettings = typeof bLazyPageSettings !== 'undefined' ? bLazyPageSettings : { selector: ".b-lazy" };


$(document).ready(function() {
    xmlSlides = new XmlSlides();
    gal = new VrBrochureView();
    helpers = new Helpers(gal);
    popups = new Popups();
    mzView = new ModernizrView(gal);
    bLazy = new Blazy(bLazySettings);
    gaScroll = new GaScroll();
    vrRelatedCatalog = new VrRelatedCatalog();
    slidersBetweenPages = new SlidersBetweenPages();

    var vrHeader = new VrHeader(),
        vrHeaderCategories = new VrHeaderCategories();

    var campRedirect = new CampRedirect(pagePromotionSettings);
    campRedirect.init();

    popups.init();
    slidersBetweenPages.init();

    gal.init();

    helpers.initBurgerButton();
    helpers.toggleLoader(1, 0);

    if (isMobile == false && typeof Related !== 'undefined') {
        related = new Related(gal);
        related.init();
    }

    document.addEventListener('view.gallery.inited', function(e) {
        scaleElem = new ScaleElem({
            parentClassName: 'vr-mobile-body__page-img-wrap'
        });

        helpers.toggleLoader(0, 0);
        globalEventListeners = new GlobalEventListeners(gal);
        globalEventListeners.init();

        /* Revalidating b-lazy imgs for related brochures left. */
        if(document.querySelectorAll('.vr-related .b-lazy').length > 0){
            bLazy.load(document.querySelectorAll('.vr-related .b-lazy'));
        }
    });
});